var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_c('vue-editor',{attrs:{"use-custom-image-handler":""},on:{"image-added":_vm.handleImageAdded},model:{value:(_vm.data.text),callback:function ($$v) {_vm.$set(_vm.data, "text", $$v)},expression:"data.text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }